<template>
	<div>
		<b-container>
			<hr/>
			<p class="h5 text-center text-dark">How much time so you want to spend on this task?</p>

			<b-row align-h="center">
				<b-col cols="4" class="p-0 text-center">
					<b-form-input v-model="instance.hours" placeholder="00" type="number" class="text-center"></b-form-input>
					<span class="text-uppercase text-blue-dark">Hours</span>
				</b-col>
				<b-col cols="4" class="p-0 text-center">
					<b-form-input v-model="instance.minutes" placeholder="00" type="number" class="text-center"></b-form-input>
					<span class="text-uppercase text-blue-dark">Minutes</span>
				</b-col>
			</b-row>

			<b-row align-h="center" class="mt-3">
				<b-col cols="8" class="p-0">
					
					<b-button @click="instance.currentComponent='timer'" class="text-uppercase bg-main" block>
						<i class="material-icons align-middle">play_arrow</i>
						Start
					</b-button>

						<!-- <b-button @click="gotimer" variant="info" class="text-uppercase" block>
						<i class="material-icons align-middle">play_arrow</i>
						Start
					</b-button> -->
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
  export default {
   props:{
				instance:{
					required:true,
					type:Object
				}
			},
		methods:{
			gotimer(){
				////console.log(this.$parent)
			}
		}
  }
</script>

<style scoped>
    .form-control{
        font-size: 4rem
    }
</style>